import { Form, Formik } from "formik";
import * as yup from "yup";
import ModalTemplate from "@/shared/components/templates/ModalTemplate/ModalTemplate";
import { Button } from "@/shared/components/ui/Button/Button";
import { SignaturePad } from "@/shared/components/ui/SignaturePad";
import {
  Actions,
  Divider,
  FormContent,
  Title,
} from "./SignatureRequiredModal.styles";

interface SignatureRequiredFormValues {
  signature: File | null;
}

export const SIGNATURE_REQUIRED_MODAL_TITLE_ID =
  "signature-required-modal-title";

export interface SignatureRequiredModalProps {
  readonly onSubmit: (signature: File) => Promise<void>;
}

const validationSchema = yup.object({
  signature: yup.mixed<File>().nullable().required(),
});

const initialValues: SignatureRequiredFormValues = {
  signature: null,
};

export const SignatureRequiredModal = ({
  onSubmit,
}: SignatureRequiredModalProps) => (
  <ModalTemplate showCloseButton={false} size="sm">
    <Title id={SIGNATURE_REQUIRED_MODAL_TITLE_ID}>
      Completá tu registro profesional con tu firma.
    </Title>

    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async ({ signature }) => {
        if (!signature) return;

        await onSubmit(signature);
      }}
    >
      {({ values, setFieldValue, isSubmitting }) => (
        <Form>
          <FormContent>
            <SignaturePad
              disabled={isSubmitting}
              onChange={(file) => {
                setFieldValue("signature", file);
              }}
            />

            <Divider />

            <Actions>
              <Button
                type="submit"
                variant="primary"
                size="lg"
                loading={isSubmitting}
                disabled={!values.signature}
              >
                Ingresar
              </Button>
            </Actions>
          </FormContent>
        </Form>
      )}
    </Formik>
  </ModalTemplate>
);
